import { FC } from 'react'

type Props = {
  href: string
  text: string
  className?: string
  target?: '_blank' | '_self' | '_parent' | '_top'
}

export const Link: FC<Props> = ({ href, text, ...prop }) => {
  return (
    <a
      href={href}
      className="font-notoSans font-medium text-[13px] leading-[31.2px] text-textPink underline decoration-solid"
      {...prop}
    >
      {text}
    </a>
  )
}
